<template>
  <span class="svg-ico-skills-domain-leadership">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.99833 2.4444C12.30613 2.4444 12.59687 2.58662 12.78639 2.82917L22.51003 15.27351C22.8498 15.7086 22.77304 16.3368 22.33817 16.67683C21.903 17.01681 21.27394 16.94001 20.93387 16.50497L11.99833 5.06747L3.06569 16.50399C2.72576 16.93916 2.0976 17.01664 1.66237 16.67683C1.22718 16.33689 1.14969 15.70873 1.48952 15.27351L11.21023 2.82917C11.3997 2.58658 11.69049 2.44443 11.99833 2.4444Z" :fill="color"/>
      <path d="M11.99799 12.9444C12.30947 12.94436 12.60369 13.0896 12.7929 13.33697L17.84953 19.94833C18.18493 20.38693 18.10153 21.01414 17.66301 21.34967C17.22437 21.68524 16.59621 21.6018 16.26069 21.16316L11.99799 15.58993L7.73919 21.16316C7.40379 21.60193 6.77563 21.68511 6.33686 21.34967C5.89834 21.01431 5.81426 20.38701 6.14936 19.94833L11.20406 13.33697L11.27923 13.24911C11.46639 13.05549 11.72546 12.94449 11.99799 12.9444Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
